export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13697.eb1cd9fa.jpg";